/**
 * Vuex module for contacts
 */
import debug from 'debug'
import API from '@/api'
import PhoneNumber from 'Store/class/contact/phone_number'
import events from 'Store/events'

const dbg = debug('store:contacts:phoneNumbers')

const actions = {
  get ({ commit, rootGetters, state }) {
    return new Promise((resolve, reject) => {
      return API.getPhoneNumbers(state.search)
        .then(response => {
          commit('RESET')
          commit('ADD_CONTACTS', response.data)
          commit('ADD_PARKINGS', rootGetters['parking/parkings'])
          commit('ADD_FEATURE_CODES', rootGetters['settings/featureCodes'])
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get contacts'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  setAutocompleteSelected ({ commit }, selected) {
    commit('AUTOCOMPLETE_SELECT', selected)
  },

  setSearch ({ commit }, search) {
    commit('SET_SEARCH', search)
  }
}

const mutations = {
  ADD_CONTACTS (state, data) {
    const phoneNumbers = []
    data.forEach(phoneNumber => {
      phoneNumbers.push(new PhoneNumber(phoneNumber))
    })
    state.phoneNumbers = [...state.phoneNumbers, ...phoneNumbers]
  },

  ADD_PARKINGS (state, data) {
    const parkings = data.map(parking => {
      const params = {
        phone_number: String(parking.extension),
        label: parking.name,
        name: 'parking',
        has_image: false,
        username: ''
      }
      return new PhoneNumber(params)
    })
    state.phoneNumbers = [...state.phoneNumbers, ...parkings]
  },

  ADD_FEATURE_CODES (state, data) {
    const featureCodes = []
    for (const [key, value] of Object.entries(data)) {
      const params = {
        phone_number: value,
        label: key,
        name: 'feature_code',
        has_image: false,
        username: ''
      }
      featureCodes.push(new PhoneNumber(params))
    }
    const leaveVoicemailUsers = []
    state.phoneNumbers.forEach(phoneNumber => {
      if (phoneNumber.contactID === null && phoneNumber.label === 'Extension') {
        const params = {
          phone_number: `*${phoneNumber.phoneNumber}`,
          label: 'leave_voicemail',
          name: 'feature_code',
          has_image: false,
          username: ''
        }
        leaveVoicemailUsers.push(new PhoneNumber(params))
      }
    })
    state.phoneNumbers = [...state.phoneNumbers, ...featureCodes, ...leaveVoicemailUsers]
  },

  RESET () {
    state.phoneNumbers = []
  },

  AUTOCOMPLETE_SELECT (state, selected) {
    state.autocompleteSelected = selected
  },

  SET_SEARCH (state, search) {
    state.search = search
  }
}

const state = {
  phoneNumbers: [],
  featureCodesWithTargetExtension: [
    'anonymouscall',
    'personalconf',
    'adhoc',
    'unadhoc',
    'intercom',
    'silenticom',
    'vm',
    'chan_spy'
  ],
  featureCodesWithTargetID: [
    'agentlogin',
    'qoffall',
    'toggle',
    'tcswitch'
  ],
  autocompleteSelected: null,
  search: null // not used
}

const getters = {
  phoneNumbers: state => state.phoneNumbers,
  autocompleteSelected: state => state.autocompleteSelected,
  search: state => state.search,
  featureCodesWithTargetExtension: state => state.featureCodesWithTargetExtension,
  featureCodesWithTargetID: state => state.featureCodesWithTargetID,
  featureCodesWithTarget: state => [...state.featureCodesWithTargetExtension, ...state.featureCodesWithTargetID]
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
